import { render, staticRenderFns } from "./statusTransportes.vue?vue&type=template&id=361484a5&"
import script from "./statusTransportes.vue?vue&type=script&lang=js&"
export * from "./statusTransportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports